const pOptions = [
  10,
  20,
  40,
  80,
  100
]
export const pageOptions = {
  pageSize: pOptions[0],
  options: pOptions
}

// 特殊人员权限设置
export const powerConfig = [
  { name: '谢勇', userName: '13520515273' },
  { name: '姚文存', userName: '13717675817' },
  { name: '吴赓', userName: '13911507270' },
  { name: '罗颖', userName: '13801323236' },
  { name: '闫本刚', userName: '13516143008' }
]

// 个人职务
export const PersonalPost = [
  { label: '实习', id: '1' },
  { label: '一级', id: '2' },
  { label: '二级', id: '3' },
  { label: '三级', id: '4' },
  { label: '四级', id: '5' },
  { label: '五级', id: '6' }
]

// 学历
export const PersonalEducation = [
  { label: '小学', value: '小学' },
  { label: '初中', value: '初中' },
  { label: '高中', value: '高中' },
  { label: '中专职高', value: '中专职高' },
  { label: '大专', value: '大专' },
  { label: '大学本科', value: '大学本科' },
  { label: '研究生硕士', value: '研究生硕士' },
  { label: '研究生博士', value: '研究生博士' },
  { label: '其他', value: '其他' }
]

// 政治面貌
export const PoliticalAppearance = [
  { label: '中共党员', value: '中共党员' },
  { label: '中共预备党员', value: '中共预备党员' },
  { label: '共青团员', value: '共青团员' },
  { label: '民革党员', value: '民革党员' },
  { label: '民建会员', value: '民建会员' },
  { label: '民进会员', value: '民进会员' },
  { label: '农工党党员', value: '农工党党员' },
  { label: '致公党党员', value: '致公党党员' },
  { label: '九三学社社员', value: '九三学社社员' },
  { label: '台盟盟员', value: '台盟盟员' },
  { label: '无党派人士', value: '无党派人士' },
  { label: '群众', value: '群众' }
]

// 保安资格证类型
export const SecurityStaffType = [
  { label: '初级', value: '初级' },
  { label: '中级', value: '中级' },
  { label: '高级', value: '高级' }
]

// 员工列表所属职务
export const StaffStationPost = [
  { label: '队员', value: '0' },
  { label: '班长', value: '1' },
  { label: '副队长', value: '2' },
  { label: '队长', value: '3' }
  // { label: '项目经理', value: '4' }
]
// 员工来源
export const SourceList = [
  { label: '人事渠道', value: '人事渠道' },
  { label: '运营渠道', value: '运营渠道' },
  { label: '网络渠道', value: '网络渠道' },
  { label: '中介渠道', value: '中介渠道' },
  { label: '熟人介绍', value: '熟人介绍' }
]

// 岗位名称
export const JobName = [
  { label: '门岗', value: '门岗' },
  { label: '员工通道', value: '员工通道' },
  { label: '重点部位岗', value: '重点部位岗' },
  { label: '停车场 ', value: '停车场 ' },
  { label: '巡逻岗', value: '巡逻岗' },
  { label: '中控岗', value: '中控岗' },
  { label: '管理岗', value: '管理岗' },
  { label: '形象岗', value: '形象岗' },
  { label: '其他岗', value: '其他岗' }
]
// 岗位类型
export const JobType = [
  { label: '普通保安岗', value: 1 },
  { label: '形象岗', value: 2 },
  { label: '中控岗', value: 3 },
  { label: '班长岗', value: 4 },
  { label: '副队长岗', value: 5 },
  { label: '兼职队长岗', value: 6 },
  { label: '专职队长岗', value: 7 }
]
// 每周工作
var WeeklyWorkarr = []
for (let i = 1; i <= 7; i++) {
  WeeklyWorkarr.push(
    { label: `${i}天`, value: i }
  )
}
export const WeeklyWork = WeeklyWorkarr

// 岗位工作总时长
var WorkingArr = []
let total = 24
let num = 0.5
for (let i = 0; i < total;) {
  i += num
  WorkingArr.push(
    { label: `${i}小时`, value: i }
  )
}
export const workingHours = WorkingArr
// 工作日选择
export const WorkdayChoice = [
  { label: '星期一', value: 1 },
  { label: '星期二', value: 2 },
  { label: '星期三', value: 3 },
  { label: '星期四', value: 4 },
  { label: '星期五', value: 5 },
  { label: '星期六', value: 6 },
  { label: '星期日', value: 7 }
]
// 班次选择

export const FlightSelection = [
  { label: 'A（白12小时）', value: 'A（白12小时）' },
  { label: 'B（夜12小时）', value: 'B（夜12小时）' },
  { label: 'C（10小时）', value: 'C（10小时）' },
  { label: 'D（9小时）', value: 'D（9小时）' },
  { label: 'E（8小时）', value: 'E（8小时）' },
  { label: 'F（6小时）', value: 'F（6小时）' },
  { label: 'G（4小时）', value: 'G（4小时）' },
  { label: 'H（3小时）', value: 'H（3小时）' },
  { label: 'I（2小时）', value: 'I（2小时）' },
  { label: 'J（1小时）', value: 'J（1小时）' },
  { label: 'K（0.5小时）', value: 'K（0.5小时）' },
  { label: 'M（13小时）', value: 'M（13小时）' },
  { label: 'L（5小时）', value: 'L（5小时）' },
  { label: 'AJK（13.5小时）', value: 'AJK（13.5小时）' }
]

export const FlightSelection2 = [
  { code: 'A（白12小时）', code_count: 0 },
  { code: 'B（夜12小时）', code_count: 0 },
  { code: 'C（10小时）', code_count: 0 },
  { code: 'D（9小时）', code_count: 0 },
  { code: 'E（8小时）', code_count: 0 },
  { code: 'F（6小时）', code_count: 0 },
  { code: 'G（4小时）', code_count: 0 },
  { code: 'H（3小时）', code_count: 0 },
  { code: 'I（2小时）', code_count: 0 },
  { code: 'J（1小时）', code_count: 0 },
  { code: 'K（0.5小时）', code_count: 0 },
  { code: 'M（13小时）', code_count: 0 },
  { code: 'L（5小时）', code_count: 0 },
  { code: 'AJK（13.5小时）', code_count: 0 },
  { code: 'T（白8小时）', code_count: 0 }
]

export const FlightSelection3 = [
  { codeName: 'A（白12小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'B（夜12小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'C（10小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'D（9小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'E（8小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'F（6小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'G（4小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'H（3小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'I（2小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'J（1小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'K（0.5小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'M（13小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'L（5小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'AJK（13.5小时）', total1: 0, total2: 0, diff: 0 },
  { codeName: 'T（白8小时）', total1: 0, total2: 0, diff: 0 }

]
// 统计班次扇形图
export const FlightSelection4 = [
  { name: 'A（白12小时）', value: 0 },
  { name: 'B（夜12小时）', value: 0 },
  { name: 'C（10小时）', value: 0 },
  { name: 'D（9小时）', value: 0 },
  { name: 'E（8小时）', value: 0 },
  { name: 'F（6小时）', value: 0 },
  { name: 'G（4小时）', value: 0 },
  { name: 'H（3小时）', value: 0 },
  { name: 'I（2小时）', value: 0 },
  { name: 'J（1小时）', value: 0 },
  { name: 'K（0.5小时）', value: 0 },
  { name: 'M（13小时）', value: 0 },
  { name: 'L（5小时）', value: 0 },
  { name: 'AJK（13.5小时）', value: 0 },
  { name: 'T（白8小时）', value: 0 }
]

// 类型选择 饼图
export const TypeSelection = [
  { label: '学历', name: 'edtions', text: '学历数量统计' },
  { label: '身高', name: 'height', text: '身高数量统计' },
  { label: '体重', name: 'weight', text: '体重数量统计' },
  { label: '年龄', name: 'age', text: '年龄数量统计' },
  { label: '省份', name: 'proviince', text: '省份数量统计' },
  { label: '保安员级别', name: 'security', text: '保安员级别' },
  { label: '资格证', name: 'card', text: '保安员证取证率分析' },
  { label: '服兵役', name: 'military', text: '服兵役' },
  { label: '一线离职率', name: 'quitrate', text: '一线离职率' }
  // { label: '项目统计', name: 'project', text: '项目统计' },
]

// 项目统计 饼图
export const projectSelection = [
  { label: '项目类型', name: 'type', text: '项目类型统计' },
  // { label: '服务等级', name: 'service', text: '服务等级统计' },
  { label: '岗位名称', name: 'postName', text: '岗位名称统计' },
  // { label: '值岗类型', name: 'postType', text: '值岗类型统计' },
  // { label: '岗位位置', name: 'postPosition', text: '岗位位置统计' },
  { label: '班次', name: 'postWorkingHours', text: '班次统计' },
  // { label: '项目统计', name: 'project', text: '项目统计' },
  { label: '规模', name: 'scale', text: '规模' }
]

// 省份
export const Province = ['北京市', '天津市', '上海市', '重庆市', '河北省', '山西省', '内蒙古', '辽宁省', '吉林省', '黑龙江省', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西', '海南省', '四川省', '贵州省', '云南省', '西藏', '陕西省', '甘肃省', '青海省', '宁夏', '新疆', '香港', '澳门', '台湾省']

// 一个月的天数
let dateArr = []
for (let i = 1; i <= 31; i++) {
  dateArr.push({ label: i, value: i })
}
export const MonthDay = dateArr

// 合同岗位类型
export const HTpostType = [
  { labe: '普通岗', value: '普通岗' },
  { labe: '专职队长岗', value: '专职队长岗' },
  { labe: '兼职队长岗', value: '兼职队长岗' },
  { labe: '专职副队长岗', value: '专职副队长岗' },
  { labe: '兼职副队长岗', value: '兼职副队长岗' },
  { labe: '形象岗', value: '形象岗' },
  { labe: '中控岗', value: '中控岗' }
]

// 岗位
export const postList = [
  { label: '董事长兼总经理', value: 1 },
  { label: '总经理助理', value: 2 },
  { label: '行政库管', value: 3 },
  { label: '运营二部经理', value: 4 },
  // { label: '总经理助理', value: 5 },
  // { label: '运营二部经理', value: 6 },
  { label: '办公室主任', value: 7 },
  { label: '运营一部经理', value: 8 },
  // { label: '办公室主任', value: 9 },
  { label: '技术主管', value: 10 },
  { label: '培训中心副主任', value: 11 },
  { label: '副总经理', value: 12 },
  { label: '主任', value: 13 },
  { label: '办公室内勤', value: 14 },
  { label: '主管', value: 15 },
  { label: '商务代表', value: 16 },
  { label: '人事经理', value: 17 },
  { label: '行政采购', value: 18 },
  { label: '出纳', value: 19 },
  { label: '会计', value: 20 },
  // { label: '副总经理', value: 21 },
  // { label: '会计', value: 22 },
  { label: '情报信息中心主任', value: 23 },
  { label: '技术员', value: 24 },
  { label: '部门经理', value: 25 },
  // { label: '副总经理', value: 26 },
  { label: '总经理', value: 27 },
  { label: '部门副经理', value: 28 },
  // { label: '办公室内勤', value: 29 },
  { label: '运营一部代经理', value: 30 },
  { label: '情报信息中心主管', value: 31 },
  { label: '人事行政总监', value: 32 },
  { label: '海外中心主任', value: 33 },
  { label: '运营内勤', value: 34 },
  { label: '人事行政主管', value: 35 },
  { label: '运营部经理', value: 36 },
  { label: '海外中心主任助理', value: 37 },
  { label: '培训中心主任', value: 38 },
  { label: '运营部经理助理', value: 39 },
  { label: '部门销售主管', value: 40 },
  { label: '总经办主任', value: 41 },
  { label: '主管', value: 42 },
  { label: '运营部-副经理', value: 43 },
  { label: '运营部-二部经理', value: 44 },
  { label: '运营部-经理', value: 45 },
  { label: '运营部内勤', value: 46 },
  // { label: '海外中心主任助理', value: 47 },
  // { label: '主管', value: 48 },
  { label: '商务代表', value: 49 },
  { label: '数据分析员', value: 52 },
  { label: '情报分析师', value: 53 },
  { label: '运营助理', value: 54 }
]
// 职级名称
export const levelList = [
  { label: '董事长兼总经理', value: '董事长兼总经理' },
  { label: '总经办主任', value: '总经办主任' },
  { label: '秘书', value: '秘书' },
  { label: '总经理', value: '总经理' },
  { label: '总经理助理', value: '总经理助理' },
  { label: '副总经理', value: '副总经理' },
  { label: '经理', value: '经理' },
  { label: '副经理', value: '副经理' },
  { label: '总监', value: '总监' },
  { label: '运营一部主管', value: '运营一部主管' },
  { label: '运营二部经理', value: '运营二部经理' },
  { label: '运营二部助理', value: '运营二部助理' },
  { label: '品牌主管', value: '品牌主管' },
  { label: '人事经理', value: '人事经理' },
  { label: '行政主管', value: '行政主管' },
  { label: '基地主任', value: '基地主任' },
  { label: '会计', value: '会计' },
  { label: '出纳', value: '出纳' },
  { label: '技术主管', value: '技术主管' },
  { label: '技术员', value: '技术员' },
  { label: '市场总监', value: '市场总监' },
  { label: '主任、高级研究员', value: '主任、高级研究员' },
  { label: '运营经理', value: '运营经理' },
  { label: '分析员', value: '分析员' },
  { label: '高级研究员', value: '高级研究员' },
  { label: '主任', value: '主任' },
  { label: '副主任', value: '副主任' },
  { label: '运营助理', value: '运营助理' },
  { label: '销售主管', value: '销售主管' },
  { label: '行政人事主管', value: '行政人事主管' },
  { label: '商务代表', value: '商务代表' }

]
// 用户层级
export const authList = [
  { label: '全部', value: '全部' },
  { label: '一级用户', value: '一级用户' },
  { label: '二级用户', value: '二级用户' },
  { label: '三级用户', value: '三级用户' },
  { label: '四级用户', value: '四级用户' },
  { label: '五级用户', value: '五级用户' }
]

// 项目性质
export const ProjectTypeList = [
  { value: null, label: '全部项目' },
  { value: 1, label: '长期保安项目' },
  { value: 2, label: '活动临保项目' },
  { value: 5, label: '随身护卫项目' },
  { value: 3, label: '联网报警项目' },
  { value: 6, label: '风险评估项目' },
  { value: 7, label: '培训项目' },
  { value: 8, label: '课题项目' },
  { value: 4, label: '其他咨询项目' },
  { value: 9, label: '安防工程项目' },
  { value: 10, label: '其他技术项目' },
  { value: 11, label: '海外项目' },
  { value: 12, label: '犬防项目' }
]

// 项目类型
export const ProjectTypeHomeList = [
  { value: 'cb', label: '长期保安项目' },
  { value: 'tb', label: '活动临保项目' },
  { value: 'lwbj', label: '联网报警项目' },
  { value: 'zx', label: '其他咨询项目' },
  { value: 'sw', label: '随身护卫项目' },
  { value: 'fp', label: '风险评估项目' },
  { value: 'px', label: '培训项目' },
  { value: 'kt', label: '课题项目' },
  { value: 'af', label: '安防工程项目' },
  { value: 'qt', label: '其他技术项目' },
  { value: 'hw', label: '海外项目' },
  { value: 'qf', label: '犬防项目' }
]

// 项目来源
export const ProjectSourceList = [
  { value: '陌生拜访', label: '陌生拜访' },
  { value: '客户引见', label: '客户引见' },
  { value: '熟人介绍', label: '熟人介绍' },
  { value: '领导交办', label: '领导交办' },
  { value: '客户自联', label: '客户自联' },
  { value: '广告宣传', label: '广告宣传' },
  { value: '网络营销', label: '网络营销' },
  { value: '其他', label: '其他' }
]
// 进程事项 -- 项目
export const matterList = [
  { value: '拜访客户', label: '拜访客户' },
  { value: '商务洽谈', label: '商务洽谈' },
  { value: '签订合同', label: '签订合同' },
  { value: '项目检查', label: '项目检查' },
  { value: '配发物资', label: '配发物资' },
  { value: '支付房租', label: '支付房租' },
  { value: '提交考勤', label: '提交考勤' },
  { value: '提交发票', label: '提交发票' },
  { value: '催收服务费', label: '催收服务费' },
  { value: '服务费到账', label: '服务费到账' },
  { value: '发放工资', label: '发放工资' },
  { value: '提交产品', label: '提交产品' },
  { value: '出差', label: '出差' },
  { value: '合同续签', label: '合同续签' },
  { value: '项目结束', label: '项目结束' },
  { value: '其他', label: '其他' }
]
// 立项 事项
export const NewMatterList = [
  { value: '拜访客户', label: '拜访客户' },
  { value: '商务洽谈', label: '商务洽谈' },
  { value: '签订合同', label: '签订合同' },
  { value: '项目检查', label: '项目检查' },
  { value: '配发物资', label: '配发物资' },
  { value: '支付房租', label: '支付房租' },
  { value: '提交考勤', label: '提交考勤' },
  { value: '提交发票', label: '提交发票' },
  { value: '催收服务费', label: '催收服务费' },
  { value: '服务费到账', label: '服务费到账' },
  { value: '发放工资', label: '发放工资' },
  { value: '提交产品', label: '提交产品' },
  { value: '出差', label: '出差' },
  { value: '合同续签', label: '合同续签' },
  { value: '项目结束', label: '项目结束' },
  { value: '其他', label: '其他' }
]
// 星期显示
export const WeekDayList = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
// 月份选择
export const MonthList = [
  { value: '1月', label: '1月' },
  { value: '2月', label: '2月' },
  { value: '3月', label: '3月' },
  { value: '4月', label: '4月' },
  { value: '5月', label: '5月' },
  { value: '6月', label: '6月' },
  { value: '7月', label: '7月' },
  { value: '8月', label: '8月' },
  { value: '9月', label: '9月' },
  { value: '10月', label: '10月' },
  { value: '11月', label: '11月' },
  { value: '12月', label: '12月' }

]

// 付款节点
export const PaymentMode = [
  { value: '预付', label: '预付' },
  { value: '中付', label: '中付' },
  { value: '后付', label: '后付' }
]
// 付款方式
export const PaymentMethod = [
  { value: '现金', label: '现金' },
  { value: '银行转账', label: '银行转账' },
  { value: '支票', label: '支票' },
  { value: '其他', label: '其他' }
]

// 排班配置或者人员配置
export const WorkTypeConfig = [
  { label: '月休四天', value: '0' },
  { label: '四包一', value: '12' },
  { label: '三包一', value: '2' },
  { label: '二包一', value: '3' },
  { label: '工作日上班', value: '4' },
  { label: '上一休一', value: '5' },
  { label: '周日休息', value: '6' },
  { label: '上二休一', value: '7' },
  { label: '上三休一', value: '8' },
  { label: '上六休一', value: '9' },
  { label: '月休15天', value: '10' },
  { label: '周六周日上班', value: '11' },
  { label: '其他', value: '1' }

]
// 序号
export const serialList = [
  { serialIndex: 1, serial: '1.合同人数(人)', totalMonth: '', totalYear: '', remark: '', name: 'contractNumber' },
  { serialIndex: 2, serial: '2.合同工时(小时)', totalMonth: '', totalYear: '', remark: '', name: 'contractWorkTime' },
  { serialIndex: 3, serial: '3.实上人数(人)', totalMonth: '', totalYear: '', remark: '以合同月总工时除以月休四天月标准工资工时312小时进行换算', name: 'actualNumber' },
  { serialIndex: 4, serial: '4.服务费单价(元)', totalMonth: '', totalYear: '', remark: '', name: 'ServiceUnitPrice' },
  { serialIndex: 5, serial: '5.服务费总额(元)', totalMonth: '', totalYear: '', remark: '', name: 'totalServiceCharge' },
  { serialIndex: 6, serial: '6.到手工资(元)', totalMonth: '', totalYear: '', remark: '运营估算员工月休四天每月到手工资', name: 'employeeWages' },
  { serialIndex: 7, serial: '7.餐费(元)', totalMonth: '', totalYear: '', remark: '', name: 'mealExpense' },
  { serialIndex: 8, serial: '8.住宿(元)', totalMonth: '', totalYear: '', remark: '', name: 'hotelExpens' },
  { serialIndex: 9, serial: '9.交通(元)', totalMonth: '', totalYear: '', remark: '', name: 'travelExpenses' },
  { serialIndex: 10, serial: '10.服装(元)', totalMonth: '', totalYear: '', remark: '', name: 'clothingExpenses' },
  { serialIndex: 11, serial: '11.被褥(元)', totalMonth: '', totalYear: '', remark: '', name: 'beddingExpenses' },
  { serialIndex: 12, serial: '12.装备(元)', totalMonth: '', totalYear: '', remark: '', name: 'equipmentCost' },
  { serialIndex: 13, serial: '13.设施(元)', totalMonth: '', totalYear: '', remark: '', name: 'facilityCost' },
  { serialIndex: 14, serial: '14.社保（个人）(元)', totalMonth: '', totalYear: '', remark: '', name: 'individualsPart' },
  { serialIndex: 15, serial: '15.社保（公司）(元)', totalMonth: '', totalYear: '', remark: '', name: 'companyPart' },
  { serialIndex: 16, serial: '16.商业保险(元)', totalMonth: '', totalYear: '', remark: '', name: 'businessInsurance' },
  { serialIndex: 17, serial: '17.法定节假日补贴(元)', totalMonth: '', totalYear: '', remark: '', name: 'legalHolidaySubsidy' },
  { serialIndex: 18, serial: '18.福利(元)', totalMonth: '', totalYear: '', remark: '', name: 'materialBenefits' },
  { serialIndex: 19, serial: '19.高温费(元)', totalMonth: '', totalYear: '', remark: '', name: 'highTemperatureSubsidy' },
  { serialIndex: 20, serial: '20.其他成本(元)', totalMonth: '', totalYear: '', remark: '', name: 'otherCost' },
  { serialIndex: 21, serial: '21.人工运营成本合计(元)', totalMonth: '', totalYear: '', remark: '', name: 'totalOperationCost' },
  { serialIndex: 22, serial: '22.税费(元)', totalMonth: '', totalYear: '', remark: '服务费的5.6%计算，可将5.6%设置为默认项，也可根据各地不同进行填写', name: 'taxAndFee' },
  { serialIndex: 23, serial: '23.核定毛利润(元)', totalMonth: '', totalYear: '', remark: '', name: 'grossProfit' },
  { serialIndex: 24, serial: '24.核定毛利率(%)', totalMonth: '', totalYear: '', remark: '', name: 'grossProfitRate' }

]

// 项目付款周期
export const PaymentOption = [
  {
    label: '月付',
    value: '月付'
  },
  {
    label: '季付',
    value: '季付'
  },
  {
    label: '半年付',
    value: '半年付'
  },
  {
    label: '年付',
    value: '年付'
  },
  {
    label: '一次性付清',
    value: '一次性付清'
  },
  {
    label: '阶段付',
    value: '阶段付'
  }
]

// 规章制度类型
export const RulesSystemType = [
  {
    value: '1',
    label: '总则'
  },
  {
    value: '2',
    label: '行政人事'
  },
  {
    value: '3',
    label: '财务'
  },
  {
    value: '4',
    label: '市场'
  },
  {
    value: '5',
    label: '运营'
  },
  {
    value: '6',
    label: '绩效'
  },
  {
    value: '7',
    label: '公司文件'
  }
]
// 合同期限
export const ContractPeriod = [
  { label: '三年', value: '1' },
  { label: '两年', value: '2' },
  { label: '一年', value: '3' },
  { label: '半年', value: '4' },
  { label: '三个月', value: '5' },
  { label: '一个月', value: '6' },
  { label: '半个月', value: '7' },
  { label: '临时', value: '8' }
]

// 考勤模块用的链接
export const EXAMFRRONT = 'https://zxks.chinashieldnet.com'
export const PATH = '/ishield'
export const HOST = 'https://zxks.chinashieldnet.com'
export const EXCELHOST = 'https://zxks.chinashieldnet.com/ishield'

// 百度秘钥
export const Ak = 'FDI4lMiVG0bKohysA9U2tTH5Kdhpk5La'
